import { Select } from 'antd';

import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import { AssignmentFilterTypes } from 'features/assignment/enums';
import { getAssignmentTerminationReasonOptions } from 'utils/assignmentUtils';

type Props = {
  filters: AssignmentFilters;
  onChange: (data: AssignmentFilters) => void;
};

export default function AssignmentTerminationReasonFilter(props: Props) {
  const { filters, onChange } = props;

  const handleFilterChange =
    (type: AssignmentFilterTypes) => (statuses: number[]) => {
      onChange({
        ...filters,
        [type]: statuses,
      });
    };

  return (
    <Select
      className="full-width"
      value={filters[AssignmentFilterTypes.TerminationReason]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a termination reason"
      onChange={handleFilterChange(AssignmentFilterTypes.TerminationReason)}
      showSearch
      data-id="assignmentTerminationReasonFilterField"
      filterOption
    >
      {getAssignmentTerminationReasonOptions().map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
}
